// let cachedInitData = null;

export const getTelegram = () => window.Telegram?.WebApp;
// export const initTelegram = () => {
//   const tg = window.Telegram?.WebApp;

//   if (tg) {
//     tg.ready();
//     tg.expand();

//     cachedInitData = tg.initData;
//   }

//   return tg;
// };

// export const getTelegramInitData = () => {
//   return window.Telegram?.WebApp?.initData || cachedInitData;
// };
export const getTelegramInitData = () => {
  return window.Telegram?.WebApp?.initData;
};
